export const styleLayer = () => {
    return  [
            {
                id: 4,
                layer:'pcalordia',
                entitielayer: 'point',
                style: {
                    'id': 'pcalordia',
                    'type': 'circle',
                    'layout': {
                    'visibility': 'visible'
                    },
                    'source': 'pcalordia',
                    /*filter: [
                    "all",
                    ['>=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
                    ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
                    ],*/
                    'source-layer': 'pcalor01',
                    'filter': ['in', 'd0', 1],
                    'paint': {
                    'circle-color': [
                            'match',
                            ['get', 'tipo'],
                            'diurno',
                            '#ebed04',
                            'nocturno',
                            'rgba(192, 41, 41, 1)',
                            //'blue',
                        /* other */ '#ccc'
                    ],
                    //'circle-radius': 2,
                    'circle-radius': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], true],
                        3,
                        2
                    ],
                    'circle-stroke-width': 1,
                    'circle-stroke-color': [
                        'match',
                        ['get', 'tipo'],
                        'diurno',
                        '#ebed04',
                        'nocturno',
                        'rgba(192, 41, 41, 1)',
                    /* other */ '#ccc'
                    ]
                    /*'circle-stroke-color': [
                        'match',
                        ['get', 'tipo'],
                        'diurno',
                        'red',
                        'nocturno',
                        '#000000',
                        '#ccc'
                    ]*/
                    }
                },
                zoom: 16,
                simbologia: 4,
                tipo: 'general'
            },
            {
                id: 50,
                layer:'estados',
                entitielayer: 'polygon',
                style: {
                'id': 'estados',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 52,
                layer:'estados2',
                entitielayer: 'polygon',
                style: {
                'id': 'estados2',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados2',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 53,
                layer:'estados3',
                entitielayer: 'polygon',
                style: {
                'id': 'estados3',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados3',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 54,
                layer:'estados4',
                entitielayer: 'polygon',
                style: {
                'id': 'estados4',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados4',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 55,
                layer:'estados5',
                entitielayer: 'polygon',
                style: {
                'id': 'estados5',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados5',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 56,
                layer:'estados6',
                entitielayer: 'polygon',
                style: {
                'id': 'estados6',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados6',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 57,
                layer:'estados7',
                entitielayer: 'polygon',
                style: {
                'id': 'estados7',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados7',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 58,
                layer:'estados8',
                entitielayer: 'polygon',
                style: {
                'id': 'estados8',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados8',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 59,
                layer:'estados9',
                entitielayer: 'polygon',
                style: {
                'id': 'estados9',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'estados9',
                'source-layer': 'estados',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 60,
                layer:'municipios',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 62,
                layer:'municipios2',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios2',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios2',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 63,
                layer:'municipios3',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios3',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios3',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 64,
                layer:'municipios4',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios4',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios4',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 65,
                layer:'municipios5',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios5',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios5',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 66,
                layer:'municipios6',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios6',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios6',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 67,
                layer:'municipios7',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios7',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios7',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 68,
                layer:'municipios8',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios8',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios8',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id: 69,
                layer:'municipios9',
                entitielayer: 'polygon',
                style: {
                'id': 'municipios9',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'municipios9',
                'source-layer': 'municipios',
                'paint': {
                    'fill-color': '#507f3d',
                    /*'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'blue',
                    '#507f3d'
                    ],*/
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom: 16,
                simbologia: 33,
                tipo: 'general'
            },
            {
                id:22,
                layer:'anp',
                entitilayer:'polygon',
                style:{
                'id': 'anp',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'anp',
                'source-layer': 'anp',
                'paint': {
                    'fill-color': '#507f3d',
                    'fill-opacity': .6,
                    'fill-outline-color': 'black'
                },
                'minzoom': 0,
                'maxzoom': 22
                },
                zoom:16,
                simbologia:88,
                tipo:'general'
            },
            {
                id:88,
                layer:'aqmodis',
                entitilayer:'polygon',
                style:{
                'id': 'aqmodis',
                'type': 'fill',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'aqmodis',
                'source-layer': 'aqmodis',
                'paint': {
                    'fill-color': '#fe992e',
                    'fill-opacity': .6,
                    'fill-outline-color': '#fe992e'
                },
                zoom:22,
                simbologia:88,
                tipo:'aquemadas'
            }
            },
            {
                id:89,
                layer:'aqmodis_outline',
                entitilayer:'line',
                style:{
                'id': 'aqmodis_outline',
                'type': 'line',
                'layout': {
                    'visibility': 'visible'
                },
                'source': 'aqmodis_outline',
                'source-layer': 'aqmodis',
                'paint': {
                    'line-color': '#fe992e',
                    'line-width': 3
                },
                zoom:22,
                simbologia:88,
                tipo:'aquemadas'
            }
        },
        {
            id: 105,
            layer:'goes_points',
            entitielayer: 'point',
            style: {
                'id': 'goes_points',
                'type': 'circle',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'goes_points',
                'filter': ['in', 'id_pais', 1],
                'paint': {
                    'circle-radius': 3,
                    'circle-stroke-width': 1,
                    'circle-color': '#e74c3c',
                    'circle-stroke-color': '#e74c3c'
                }
            },
            zoom: 16,
            simbologia: 105,
            tipo: 'general'
        },
        {
            id: 106,
            layer:'goes_heatmap_points',
            entitielayer: 'point',
            style: {
                'id': 'goes_heatmap_points',
                'type': 'circle',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'goes_heatmap_points',
                'filter': ['in', 'id_pais', 1],
                'minzoom': 8,
                'paint': {
                    'circle-radius': 3,
                    'circle-stroke-width': 1,
                    'circle-color': '#e74c3c',
                    'circle-stroke-color': '#e74c3c'
                }
            },
            zoom: 16,
            simbologia: 106,
            tipo: 'general'
        },
        {
            id: 107,
            layer:'goes_heatmap',
            entitielayer: 'point',
            style: {
                'id': 'goes_heatmap',
                'type': 'heatmap',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'goes_heatmap',
                'filter': ['in', 'id_pais', 1],
                'maxzoom': 10,
                'paint': {
                    // increase weight as diameter breast height increases
                    // increase intensity as zoom level increases
                    'heatmap-intensity': {
                        stops: [
                        [11, 1],
                        [15, 3]
                        ]
                    },
                    // assign color values be applied to points depending on their density
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0,
                        'rgba(236,222,239,0)',
                        0.2,
                        '#fef5e7',
                        0.4,
                        '#fdebd0',
                        0.6,
                        '#fad7a0',
                        0.8,
                        '#f8c471'
                    ],
                    // increase radius as zoom increases
                    'heatmap-radius': {
                        stops: [
                        [11, 15],
                        [15, 20]
                        ]
                    },
                    // decrease opacity to transition into the circle layer
                    'heatmap-opacity': {
                        default: 1,
                        stops: [
                        [14, 1],
                        [15, 0]
                        ]
                    }

                }
            },
            zoom: 5,
            simbologia: 106,
            tipo: 'general'
        },
        {
            id: 108,
            layer:'goes_fdcf_10min',
            entitielayer: 'point',
            style: {
                'id': 'goes_fdcf_10min',
                'type': 'circle',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'goes_fdcf_10min',
                'filter': ['in', 'id_pais', 1],
                'maxzoom': 12,
                'paint': {
                    'circle-radius': 3,
                    'circle-stroke-width': 1,
                    'circle-color': '#e74c3c',
                    'circle-stroke-color': '#e74c3c'
                }
                //'paint': {
                //    'circle-radius': 3,
                //    'circle-stroke-width': 1,
                //    'circle-color': {
                //        property: 'Power',
                //        type: 'exponential',
                //        stops: [
                //          [20, '#faebdd'],
                //          [50, '#f58860'],
                //         [100, '#cb1b4f'],
                //          [200, '#611f53'],
                //          [300, '#03051a']
                //        ]
                //      },
                //    'circle-stroke-color': 'red'
                //}
            },
            zoom: 5,
            simbologia: 108,
            tipo: 'general'
        },

        {
            id: 109,
            layer:'goes_fdcf_heatmap_points',
            entitielayer: 'point',
            style: {
                'id': 'goes_fdcf_heatmap_points',
                'type': 'circle',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'goes_fdcf_heatmap_points',
                'filter': ['in', 'id_pais', 1],
                'minzoom': 8,
                'paint': {
                    'circle-radius': 3,
                    'circle-stroke-width': 1,
                    'circle-color': '#e74c3c',
                    'circle-stroke-color': '#e74c3c'
                }
            },
            zoom: 16,
            simbologia: 109,
            tipo: 'general'
        },
        {
            id: 110,
            layer:'goes_fdcf_heatmap',
            entitielayer: 'point',
            style: {
                'id': 'goes_fdcf_heatmap',
                'type': 'heatmap',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'goes_fdcf_heatmap',
                'filter': ['in', 'id_pais', 1],
                'maxzoom': 10,
                'paint': {
                    // increase weight as diameter breast height increases
                    // increase intensity as zoom level increases
                    'heatmap-intensity': {
                        stops: [
                        [11, 1],
                        [15, 3]
                        ]
                    },
                    // assign color values be applied to points depending on their density
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0,
                        'rgba(236,222,239,0)',
                        0.2,
                        '#fef5e7',
                        0.4,
                        '#fdebd0',
                        0.6,
                        '#fad7a0',
                        0.8,
                        '#f8c471'
                    ],
                    // increase radius as zoom increases
                    'heatmap-radius': {
                        stops: [
                        [11, 15],
                        [15, 20]
                        ]
                    },
                    // decrease opacity to transition into the circle layer
                    'heatmap-opacity': {
                        default: 1,
                        stops: [
                        [14, 1],
                        [15, 0]
                        ]
                    }

                }
            },
            zoom: 5,
            simbologia: 109,
            tipo: 'general'
        },
        {
            id: 120,
            layer:'rave',
            entitielayer: 'point',
            style: {
                'id': 'rave',
                'type': 'circle',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'rave',
                'filter': ['in', 'id_pais', 1],
                'maxzoom': 12,
                'paint': {
                    'circle-radius': 4,
                    'circle-stroke-width': 1.0,
                    'circle-color': {
                        property: 'CO2',
                        type: 'exponential',
                        stops: [
                            [0, '#2b83ba'],
                            [5e4, '#5aa4b2'],
                            [10e4, '#88c4aa'],
                            [20e4, '#b3e0a6'],
                            [30e4, '#d1ecb0'],
                            [40e4, '#f0f9ba'],
                            [50e4, '#fff0ae'],
                            [60e4, '#fed38c'],
                            [70e4, '#fdb56a'],
                            [80e4, '#f3854e'],
                            [90e4, '#e54f35'],
                            [100e4, '#820dbc']
                        ]
                      },
                    'circle-stroke-color': '#FFFFFF'
                }
            },
            zoom: 5,
            simbologia: 120,
            tipo: 'general'
        },
        {
            id: 121,
            layer:'rave_24h',
            entitielayer: 'point',
            style: {
                'id': 'rave_24h',
                'type': 'circle',
                'layout': {
                'visibility': 'visible'
                },
                'source': 'rave_24h',
                'filter': ['in', 'id_pais', 1],
                'maxzoom': 12,
                'paint': {
                    'circle-radius': 4,
                    'circle-stroke-width': 1.0,
                    'circle-color': {
                        property: 'CO2',
                        type: 'exponential',
                        stops: [
                            [0, '#2b83ba'],
                            [5e4, '#5aa4b2'],
                            [10e4, '#88c4aa'],
                            [20e4, '#b3e0a6'],
                            [30e4, '#d1ecb0'],
                            [40e4, '#f0f9ba'],
                            [50e4, '#fff0ae'],
                            [60e4, '#fed38c'],
                            [70e4, '#fdb56a'],
                            [80e4, '#f3854e'],
                            [90e4, '#e54f35'],
                            [100e4, '#820dbc']
                        ]
                      },
                    'circle-stroke-color': '#FFFFFF'
                }
            },
            zoom: 5,
            simbologia: 121,
            tipo: 'general'
        },





    ]
}